import React, { Component } from 'react';
import IndeterminateProgress from './IndeterminateProgress.js';
import Util from './Util.js';

class SpreadJS extends Component {

    static s_instanceId = 1;
    constructor(props) {
        super(props);

        this.sjsFrame = React.createRef();

        this.state = { spreadObj: null };
        this.getJSON = this.getJSON.bind(this);
        this.updateJson = this.updateJson.bind(this);
        this.state.isloaded = true;
        this.waitForSpreadJsLoadCount = 0;

        this.instanceId = SpreadJS.s_instanceId++;
    }

    componentDidMount() {
        let myClass = this
        let sjsFrameElement = this.sjsFrame.current;
        this.innerWindow = sjsFrameElement.contentWindow;
        this.innerObjectRoot = this.innerWindow.window;
        this.innerDocument = sjsFrameElement.contentDocument || sjsFrameElement.contentWindow.document;
        if (typeof this.innerObjectRoot.spreadJsLoaded === 'undefined' ||
            this.innerObjectRoot.spreadJsLoaded != true) {
            console.log('componentDidMount WaitForSingleObject' + this.instanceId)
            this.innerObjectRoot.componentDidMount = () => this.componentDidMount()
            return
        }
        console.log('componentDidMount Running' + this.instanceId);
        let divSpreadJsBorder = document.getElementById("divSpreadJsBorder" + this.instanceId)
        let prgLoadSpreadJs = document.getElementById("prgLoadSpreadJs" + this.instanceId)
        divSpreadJsBorder.removeChild(prgLoadSpreadJs)

        let lang = Util.GetCurrentCultureName();
        this.innerObjectRoot.GC.Spread.Common.CultureManager.culture(lang);

        this.props.resizeViewer();

        let spread = new this.innerObjectRoot.GC.Spread.Sheets.Workbook(
            this.innerDocument.getElementById('spreadjs'), { sheetCount: 1 });

        // make the col with and row height same as spread.services and excel
        let worksheet = spread.getActiveSheet();
        worksheet.defaults.colWidth = 64;
        worksheet.defaults.rowHeight = 20;
        myClass.state.spreadObj = spread;
        myClass.loadJson(myClass.props.json);
    }

    updatePivottableviewsPanel() {
        let worksheet = this.state.spreadObj.getActiveSheet();
        let pivotTableManager;
        try {
            pivotTableManager = worksheet.pivotTables;
        } catch (e) {
            return;
        }
        let pivotTable = worksheet.pivotTables.all()[0];
        let pivotpanel = this.innerDocument.getElementById("rightPlugin");
        new this.innerObjectRoot.GC.Spread.Pivot.PivotPanel("myPivotPanel", pivotTable, pivotpanel);
    }

    updateTableSheetsPanel() {
        let worksheet = this.state.spreadObj.getActiveSheetTab();

        if (worksheet !== null) {
            let sheetPanel = this.innerDocument.getElementById("rightPlugin");
            new this.innerObjectRoot.GC.Spread.Sheets.TableSheet.TableSheetPanel("mySheetPanel", worksheet, sheetPanel);
        }
    }

    doProtect(spread, readOnly) {
        spread.options.newTabVisible = false;
        spread.options.tabEditable = false;
        spread.options.allowSheetReorder = false;
        spread.options.allowUserEditFormula = false;
        spread.options.allowContextMenu = false;
        if (readOnly) {
            for (let i = 0; i < spread.getSheetCount(); i++) {
                spread.sheets[i].options.isProtected = true;
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        var newJson = this.props.json;
        this.props.resizeViewer();
        if (prevProps.json != this.props.json) {
            this.loadJson(newJson);
        }
    }

    openSsjsonFileAsync(spread, newJson, continuation) {
        const bytes = new TextEncoder().encode(newJson)
        const blob = new Blob([bytes], {
            type: "application/json;charset=utf-8"
        })
        console.log("openSsjsonFile running")
        spread.import(blob, () => {
            console.log("openSsjsonFile:OK")
            if (typeof continuation === "function") {
                continuation()
            }
            this.notifyFileOpenedForTests();
        }, ex => {
            console.log("openSsjsonFile:Error:" + JSON.stringify(ex))
        }, {
            fileType: this.innerObjectRoot.GC.Spread.Sheets.FileType.ssjson
        })
    }

    notifyFileOpenedForTests() {
        if (typeof window.spreadFileOpened === "function") {
            window.spreadFileOpened();
        }
    }

    loadJson(newJson) {
        const myClass = this
        let delayTaskPaneLayout = false
        if (newJson == null) {
            console.log("loadJson canceled: newJson is null." + this.instanceId)
            return;
        }
        if (this.state.spreadObj == null) {
            console.log("loadJson canceled: spread not loaded." + this.instanceId)
            return
        }
        console.log("loadJson running" + this.instanceId)
        // We clone the JSON, because Spread JS may modify it when loading asynchronously.
        if (this.props.type === 'json') {
            delayTaskPaneLayout = true
            this.openSsjsonFileAsync(this.state.spreadObj, newJson, () => {
                myClass.updateSpreadJS(myClass.state.spreadObj, myClass.props.exampleId);
                myClass.doProtect(myClass.state.spreadObj, myClass.props.readOnly);
                myClass.updateTaskPaneLayout();
            });
        } else if (this.props.type === 'sjs') {
            if (this.state.isloaded === true) {
                this.state.isloaded = false;
                this.state.spreadObj.open(new File([newJson], "file.sjs"), function () {
                    myClass.notifyFileOpenedForTests();
                    myClass.state.isloaded = true;
                    myClass.updateSpreadJS(myClass.state.spreadObj, myClass.props.exampleId);
                    myClass.doProtect(myClass.state.spreadObj, myClass.props.readOnly);
                }, function (e) {
                    myClass.state.isloaded = true;
                }, {
                    includeFormulas: false
                });
            }
        } else if (this.props.type === 'object') {
            this.state.spreadObj.fromJSON(newJson);
            this.updateSpreadJS(this.state.spreadObj, this.props.exampleId);
            this.doProtect(this.state.spreadObj, this.props.readOnly);
        } else {
            console.log("Unknown type: " + this.props.type + " in " + this.instanceId)
        }

        if (!delayTaskPaneLayout) {
            this.updateTaskPaneLayout();
        }
    }

    updateTaskPaneLayout() {
        if (this.props.updateFeaturePlugin) {
            this.updateFeaturePlugin();
        } else {
            this.setTaskPaneVisible(false);
        }
    }

    setTaskPaneVisible(value) {
        let spreadjs = this.innerDocument.getElementById("spreadjs");
        let rightPlugin = this.innerDocument.getElementById("rightPlugin");
        if (value) {
            rightPlugin.classList.add("featurePlugin");
            rightPlugin.classList.remove("disableFeature");
            spreadjs.classList.add("spreadJSHasPlugin");
            spreadjs.classList.remove("spreadJSNoPlugin");
        }
        else {
            rightPlugin.classList.remove("featurePlugin");
            rightPlugin.classList.add("disableFeature");
            spreadjs.classList.remove("spreadJSHasPlugin");
            spreadjs.classList.add("spreadJSNoPlugin");
        }
        this.state.spreadObj.refresh()
    }

    getJSON() {
        if (this.state.spreadObj == null) {
            return ""
        }
        return this.state.spreadObj.toJSON();
    }

    refresh() {
        if (this.state.spreadObj == null) {
            return
        }
        this.state.spreadObj.refresh();
    }

    updateJson(json, id) {
        var spreadObj = this.state.spreadObj;
        var sheet = spreadObj.getActiveSheet();
        if (id === 'namedstyletojson') {
            var style = new this.innerObjectRoot.GC.Spread.Sheets.Style();
            style.fromJSON(json);
            sheet.setStyle(3, 3, style);
        } else if (id === 'tabletojson') {
            sheet.tables.fromJSON(json);
        } else if (id === 'datavalidationtojson') {
            let dv = this.innerObjectRoot.GC.Spread.Sheets.DataValidation.createNumberValidator(
                this.innerObjectRoot.GC.Spread.Sheets.ConditionalFormatting.ComparisonOperators.between, "5", "20", true);
            dv.fromJSON(json, null, sheet);
            this.state.spreadObj.options.highlightInvalidData = true;
            sheet.setDataValidator(1, 2, 3, 3, dv);
        } else if (id === 'formatstojson') {
            sheet.conditionalFormats.fromJSON(json);
        } else if (id === 'top10tojson') {
            var cfs = sheet.conditionalFormats;
            var top10 = cfs.addTop10Rule();
            top10.fromJSON(json);
            cfs.removeRule(top10);
            cfs.addRule(top10);
        } else if (id === 'sparklinetojson') {
            let sparkline1 = sheet.getSparkline(2, 5);
            let sparkline2 = sheet.getSparkline(3, 5);
            let sparkline3 = sheet.getSparkline(4, 5);
            let group = sheet.groupSparkline([sparkline1, sparkline2, sparkline3]);
            group.fromJSON(json);
        }

        this.refresh();
    }

    updateSpreadJS(spread, exampleId) {
        if (exampleId == "jsoniorowcolumncount" || exampleId == "ignorerangeoutofrowcolumncount") {
            return
        }
        for (let index = 0; index < spread.getSheetCount(); index++) {
            spread.sheets.forEach(function (worksheet) {
                if (worksheet.getRowCount() < 200) {
                    worksheet.setRowCount(200);
                }
                if (worksheet.getColumnCount() < 30) {
                    worksheet.setColumnCount(30);
                }
            })
        }
    }

    updateFeaturePlugin() {
        if (this.props.readOnly) {
            if (this.props.exampleId === 'pivottableviews') {
                this.updatePivottableviewsPanel();
            } else if (this.props.exampleId === 'tablesheets') {
                this.updateTableSheetsPanel();
            }

            this.setTaskPaneVisible(true);
        }
    }

    render() {
        return (
            <div id={"divSpreadJsBorder" + this.instanceId}>
                <IndeterminateProgress id={"prgLoadSpreadJs" + this.instanceId} />
                <iframe ref={this.sjsFrame} style={{ width: "100%", height: "564px", paddingLeft: "0px", paddingRight: "0px" }} frameBorder="0" title="spread-js-frame" src="SpreadJS" scrolling="no">

                </iframe>
            </div>
        );
    }
}

export default SpreadJS;
